// As strings do voucher de agendamento (a corrida agendada com motorista,
// `buildScheduledRideVoucherView`, #5030, e a diária com motorista, `buildCarDriverVoucherView`,
// #6876), em arquivo próprio pelo mesmo motivo do `hotel_voucher_catalog.ts`: o catálogo
// principal tem teto de 500 linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.scheduledRideVoucher.title': 'Agendamento',
  'trips.scheduledRideVoucher.scheduled': 'Agendado',
  'trips.scheduledRideVoucher.confirmedOn': 'Confirmado em {{date}}',
  'trips.scheduledRideVoucher.arrival': 'Chegada prevista {{time}}',
  'trips.scheduledRideVoucher.driver': 'Motorista',
  'trips.scheduledRideVoucher.agreed': 'Valor acordado',
  'trips.scheduledRideVoucher.extraCharges': 'Pedágios e espera podem gerar cobrança extra.',
  'trips.scheduledRideVoucher.priceAdjusted': 'Valor ajustado: {{reason}}',
  'trips.carDriverVoucher.title': 'Carro com motorista',
  'trips.carDriverVoucher.dates': 'Início · {{date}}',
  'trips.carDriverVoucher.daysLabel': 'Diárias',
  'trips.carDriverVoucher.days_one': '{{count}} diária',
  'trips.carDriverVoucher.days_other': '{{count}} diárias',
  'trips.carDriverVoucher.package': 'Pacote',
  'trips.carDriverVoucher.packageHours': 'Diária de {{hours}} h',
  'trips.carDriverVoucher.packageHoursKm': 'Diária de {{hours}} h com {{km}} km',
  'trips.carDriverVoucher.dailies_one': '{{count}} diária × {{price}}',
  'trips.carDriverVoucher.dailies_other': '{{count}} diárias × {{price}}',
  'trips.carDriverVoucher.bilingual': 'Motorista bilíngue',
  'trips.carDriverVoucher.overnight': 'Pernoite',
  'trips.carDriverVoucher.overnightNights_one': 'Pernoite · {{count}} noite',
  'trips.carDriverVoucher.overnightNights_other': 'Pernoite · {{count}} noites',
  'trips.carDriverVoucher.extraCharges': 'Horas e km além do pacote podem gerar cobrança extra.',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.scheduledRideVoucher.title': 'Scheduled ride',
  'trips.scheduledRideVoucher.scheduled': 'Scheduled',
  'trips.scheduledRideVoucher.confirmedOn': 'Confirmed on {{date}}',
  'trips.scheduledRideVoucher.arrival': 'Estimated arrival {{time}}',
  'trips.scheduledRideVoucher.driver': 'Driver',
  'trips.scheduledRideVoucher.agreed': 'Agreed price',
  'trips.scheduledRideVoucher.extraCharges': 'Tolls and waiting time may add extra charges.',
  'trips.scheduledRideVoucher.priceAdjusted': 'Price adjusted: {{reason}}',
  'trips.carDriverVoucher.title': 'Car with driver',
  'trips.carDriverVoucher.dates': 'Starts · {{date}}',
  'trips.carDriverVoucher.daysLabel': 'Days',
  'trips.carDriverVoucher.days_one': '{{count}} day',
  'trips.carDriverVoucher.days_other': '{{count}} days',
  'trips.carDriverVoucher.package': 'Package',
  'trips.carDriverVoucher.packageHours': '{{hours}} h a day',
  'trips.carDriverVoucher.packageHoursKm': '{{hours}} h and {{km}} km a day',
  'trips.carDriverVoucher.dailies_one': '{{count}} day × {{price}}',
  'trips.carDriverVoucher.dailies_other': '{{count}} days × {{price}}',
  'trips.carDriverVoucher.bilingual': 'Bilingual driver',
  'trips.carDriverVoucher.overnight': 'Overnight stay',
  'trips.carDriverVoucher.overnightNights_one': 'Overnight stay · {{count}} night',
  'trips.carDriverVoucher.overnightNights_other': 'Overnight stay · {{count}} nights',
  'trips.carDriverVoucher.extraCharges': 'Hours and km beyond the package may add extra charges.',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.scheduledRideVoucher.title': 'Agendamiento',
  'trips.scheduledRideVoucher.scheduled': 'Agendado',
  'trips.scheduledRideVoucher.confirmedOn': 'Confirmado el {{date}}',
  'trips.scheduledRideVoucher.arrival': 'Llegada prevista {{time}}',
  'trips.scheduledRideVoucher.driver': 'Conductor',
  'trips.scheduledRideVoucher.agreed': 'Valor acordado',
  'trips.scheduledRideVoucher.extraCharges': 'Peajes y espera pueden generar cobro extra.',
  'trips.scheduledRideVoucher.priceAdjusted': 'Valor ajustado: {{reason}}',
  'trips.carDriverVoucher.title': 'Coche con conductor',
  'trips.carDriverVoucher.dates': 'Inicio · {{date}}',
  'trips.carDriverVoucher.daysLabel': 'Diarias',
  'trips.carDriverVoucher.days_one': '{{count}} diaria',
  'trips.carDriverVoucher.days_other': '{{count}} diarias',
  'trips.carDriverVoucher.package': 'Paquete',
  'trips.carDriverVoucher.packageHours': 'Diaria de {{hours}} h',
  'trips.carDriverVoucher.packageHoursKm': 'Diaria de {{hours}} h con {{km}} km',
  'trips.carDriverVoucher.dailies_one': '{{count}} diaria × {{price}}',
  'trips.carDriverVoucher.dailies_other': '{{count}} diarias × {{price}}',
  'trips.carDriverVoucher.bilingual': 'Conductor bilingüe',
  'trips.carDriverVoucher.overnight': 'Pernocte',
  'trips.carDriverVoucher.overnightNights_one': 'Pernocte · {{count}} noche',
  'trips.carDriverVoucher.overnightNights_other': 'Pernocte · {{count}} noches',
  'trips.carDriverVoucher.extraCharges': 'Horas y km fuera del paquete pueden generar cobro extra.',
};

export const SCHEDULED_RIDE_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
